<div class="col-sm-12 col-md-3 col-xl-3 mb-3" *ngFor="let content of posts ? posts.slice(0,4):[]">
    <div class="card border-0 border-rad m-0" style="min-height: 440px; max-height: 440px; height: 440px;" (click)="redirecionar(content)">
        <a style="cursor: pointer;"><img class="border-rad-top img-fluid w-100" [src]="content?.imagem"
                alt="Card image cap" width="370" height="253" /></a>
        <div class="card-body px-4 pt-4 border-rad-bottom" style="cursor: pointer;">
            <h5 class="card-title mb-3" style="text-align: center;"><a style="cursor: pointer;">{{content?.titulo}}</a></h5>
            <p class="card-text mb-4" style="height: 90px;min-height: 90px; max-height: 90px;">{{content?.conteudo}}</p>
        </div>
    </div>
</div>